export const ACTIVE = 'ACTIVE';
export const INCOMPLETE = 'REGISTRATION_INCOMPLETE';
